import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { StyledFaqBanner, TextContainer } from './style';
import Icon from '../../atoms/Icon';
import { CTA, Text } from '../../atoms';
import routes from '../../../routes';
import { isPublicPath } from '../../../utils/common';

const FaqBanner = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isPublic = () => isPublicPath(pathname);

  const handleOnClick = () => {
    if (isPublic()) navigate(routes.publicFaq.path);
    else navigate(routes.faq.path);
  };

  return (
    <StyledFaqBanner>
      <div>
        <Icon
          type="help-circle"
          size={40}
          clickable={false}
          stroke="currentColor"
        />
        <TextContainer>
          <Text type="h2">
            Hai bisogno di aiuto? Consulta la sezione domande frequenti
          </Text>
          <CTA
            type="tertiary"
            btnText="Tutte le domande frequenti"
            icon="arrow-narrow-right"
            onClick={handleOnClick}
          />
        </TextContainer>
      </div>
    </StyledFaqBanner>
  );
};

export default FaqBanner;
